import React, {useState} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TeamList from "./screens/TeamList";
import TeamMember from "./screens/TeamMember";
import AddTeamMember from "./screens/AddTeamMember";
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from "./components/Footer/Footer";
import Top from "./components/Top/Top";
import "./App.css"
import NotFound from "./screens/NotFound";
import { Container } from "react-bootstrap";


const App = () => (



  <Router>
   <Top/>
   <Container fluid={true}>
    <Routes>
      <Route path="/" element={<TeamList />} />
      {/* <Route path="/team/:id" exact element={<TeamMember />} /> */}
      <Route path="/team/:lname" exact element={<TeamMember />} />



      <Route path="/add-member"  exact element={<AddTeamMember />} />
      {/* Fallback 404 route - must be last */}
      <Route path="*" exact element={<NotFound />} />
    </Routes>

    </Container>
    <Footer/>
  </Router>
);

export default App;

